import styles from './WarrantyReportsTable.module.css'
import { Table } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import './WarrantyReportsTable.css'
import { useTranslation } from 'react-i18next'
import {ReactComponent as PencilIcon} from 'assets/icons/pencilIcon.svg'
import { axiosConfig } from 'utils/axiosConfig'
import { useEffect, useState } from 'react'
import moment from 'moment'
function WarrantyReportsTable(props:any) {
    const {month ,year,searchTerm} = props
    const {t} = useTranslation()
    const [items,setItems]=useState([])
    const [currentPage,setCurrentPage]=useState(1)
    const [pages,setPages]=useState(null)
    function getAllItems(){
        axiosConfig.get(`/user/users-products-warranty-status?page=${currentPage}&month=${month}&year=${year}&name=${searchTerm}`,{
            headers: {
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            }
        }).then(res=>{
            setItems(res.data?.data)
            // setPages(res.data?.data?.pages)
        }).catch(err=>{
            console.log(err)
        })
    }
    useEffect(()=>{
        getAllItems()
    },[month,year,searchTerm])
    return (
        <>
            <Table responsive striped className={`${styles['appointments__table']} table table-responsive`}>
                <thead>
                    <th>{t('Device Name')}</th>
                    <th>{t('Client Name')}</th>
                    <th>{t('Warranty End Date')}</th>
                </thead>
                <tbody>
                    {
                        items && items?.map((item:any)=>(
                            <tr key={item?._id}>
                                <td>
                                    <p className={styles['appointments__table-name']}>{item?.product?.translation?.en?.title}</p>
                                </td>
                                <td>
                                    <Link to={`/our-clients/client-details/${item?._id}`} className={styles['appointments__table-link']}>
                                        {item?.name}
                                    </Link>
                                </td>
                                <td>
                                    <p className={styles['appointments__table-name']}>{moment(item?.product?.warranty_end_date||'').format('YYYY/MM/DD')}</p>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
        </>
    )
}

export default WarrantyReportsTable